import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, catchError, map, Observable, switchMap, take, tap, throwError } from 'rxjs';
import { BaseRespone, PaginationResult } from 'src/app/models/common.response';
import { environment } from 'src/environments/environment';
import { IPrescriptionTemplate } from '../../opd/prescription/iprescription';

@Injectable({
    providedIn: 'root'
})
export class PrescriptionTemplateService {

    private _prescriptionTemplate: BehaviorSubject<IPrescriptionTemplate | null> = new BehaviorSubject<IPrescriptionTemplate | null>(null);
    private _prescriptionTemplates: BehaviorSubject<IPrescriptionTemplate[] | null> = new BehaviorSubject<IPrescriptionTemplate[] | null>(null);
    private _pagination: BehaviorSubject<PaginationResult | null> = new BehaviorSubject<PaginationResult | null>(null);



    constructor(private _httpClient: HttpClient) { }

    get PrescriptionTemplate$(): Observable<IPrescriptionTemplate | null> {
        return this._prescriptionTemplate.asObservable();
    }

    get PrescriptionTemplates$(): Observable<IPrescriptionTemplate[] | null> {
        return this._prescriptionTemplates.asObservable();
    }

    get pagination$(): Observable<PaginationResult | null> {
        return this._pagination.asObservable();
    }




    createPrescriptionTemplate(prescriptionTemplateData: IPrescriptionTemplate): Observable<BaseRespone<IPrescriptionTemplate>> {
        return this._httpClient.post<BaseRespone<IPrescriptionTemplate>>(`${environment.baseURl}/PrescriptionTemplate`, prescriptionTemplateData).pipe(
            tap((response) => {
                this._prescriptionTemplate.next(response.result);
            }),
            catchError((error) => {
                console.error('Error creating Prescription Template:', error);
                throw error;
            })
        );
    }

    getPrescriptionTemplateById(Id: number) {
        return this._httpClient.get<BaseRespone<IPrescriptionTemplate>>(`${environment.baseURl}/PrescriptionTemplate/${Id}`).pipe(
            tap((response) => {
                this._prescriptionTemplate.next(response.result);
            }),
            catchError((error) => {
                return throwError(() => error.error);
            })
        );
    }

    //   getAllPrescription(prescriptiondata: PaginationRequest): Observable<BaseRespone<{ pagination: PaginationResult; prescriptionDetails: IPrescription[] }>> {
    //     return this._httpClient.post<BaseRespone<{ pagination: PaginationResult; prescriptionDetails: IPrescription[] }>>(`${environment.baseURl}/Prescription/List`, prescriptiondata).pipe(
    //       tap((response) => {
    //         this._pagination.next(response.result.pagination);
    //         this._prescriptions.next(response.result.prescriptionDetails);
    //       }),
    //       catchError((error) => {
    //         console.error('Error fetching data:', error);
    //         throw error;
    //       })
    //     );
    //   }

    //   deletePrescription(id: number): Observable<BaseRespone<boolean>> {
    //     return this.prescriptions$.pipe(
    //       take(1),
    //       switchMap(prescription =>
    //         this._httpClient.delete<BaseRespone<boolean>>(`${environment.baseURl}/Prescription/${id}`).pipe(
    //           map((deletedResponse) => {
    //             if (deletedResponse.result) {

    //               const updated = (prescription ?? []).filter(item => item.id !== id);
    //               this._prescriptions.next(updated);
    //             }
    //             return deletedResponse;
    //           })
    //         )
    //       ), catchError((error) => {
    //         console.error('Error to Fetching data:', error);
    //         throw error;
    //       })
    //     );
    //   }

    //   updatePrescription(prescriptiondetails: IPrescription): Observable<BaseRespone<IPrescription>> {
    //     return this.prescriptions$.pipe(
    //       take(1),
    //       switchMap(prescriptions => this._httpClient.put<BaseRespone<IPrescription>>(`${environment.baseURl}/Prescription`, prescriptiondetails)
    //         .pipe(
    //           tap((updatedResponse) => {
    //             const list = prescriptions ?? [];
    //             const updatedList = list.map(item =>
    //               item.id === prescriptiondetails.id ? prescriptiondetails : item
    //             );
    //             this._prescriptions.next(updatedList);
    //           })
    //         )
    //       ),
    //       catchError(error => {
    //         console.error('Error updating Prescription:', error);
    //         throw error;
    //       })
    //     );
    //   }


}

